import {
  IGroupDto,
  IRoleDto,
  IUserRoleDto,
  UserRoleUpdateDto
} from '../../api/mandant.types';

export const isUserAdministrator = (row: IUserRoleDto) => {
  return row.systemRoles.some((group) => group === 'Administration');
};


export const isUserRegistered: (row: IUserRoleDto) => boolean = function (
  row: IUserRoleDto
): boolean {
  return Boolean(row.firstName && row.lastName);
};

